import { useContext } from "react";
import logo from "../../assets/img/logo.png";
import { AdminContext } from "../../context/AdminContext";
import { Link, useLocation  } from "react-router-dom";

const AdminSidebar = () => {
  const {
    handleLogoutClick,
    handleSidebarClose,
  } = useContext(AdminContext);

  const location = useLocation();
const isActive = (path, exact = false) => {
  return exact ? location.pathname === path : location.pathname.startsWith(path);
};
  return (
    <div className="dashboard_sidebar d-flex flex-column justify-content-between">
      {/* Sidebar Close Button (visible on mobile only) */}
      <div className="d-lg-none text-end siderbarclosebtn">
        <button
          className="btn-close"
          id="sidebarClose"
          aria-label="Close"
          onClick={handleSidebarClose}
        ></button>
      </div>

      <div>
        <div className="logo mb-4 d-flex align-items-center gap-2">
          <img src={logo} alt="Industry & People" className="img-fluid" />
        </div>
        <ul className="nav flex-column">
          
          <li className="nav-item mb-3">
              <Link
                to={"/adminDashboard"}
                style={{ textDecoration: "none" }}
                className={`nav-link ${
                  isActive("/adminDashboard",true) ? "active" : ""
                }`}
              >
                <i className={`bi bi-grid-fill`}></i>
                Dashboard
              </Link>
            </li><li className="nav-item mb-3">
              <Link
                to={"/adminDashboard/companies"}
                style={{ textDecoration: "none" }}
                className={`nav-link ${
                  isActive("/adminDashboard/companies") ? "active" : ""
                }`}
              >
                <i className={`bi bi-buildings-fill`}></i>
                Companies
              </Link>
            </li><li className="nav-item mb-3">
              <Link
                to={"/adminDashboard/inp-panel"}
                style={{ textDecoration: "none" }}
                className={`nav-link ${
                  isActive("/adminDashboard/inp-panel") ? "active" : ""
                }`}
              >
                <i className={`bi bi-people-fill`}></i>
                INP Panel
              </Link>
            </li><li className="nav-item mb-3">
              <Link
                to={"/adminDashboard/wallet"}
                style={{ textDecoration: "none" }}
                className={`nav-link ${
                  isActive("/adminDashboard/wallet") ? "active" : ""
                }`}
              >
                <i className={`bi bi-wallet2`}></i>
                Wallet
              </Link>
            </li><li className="nav-item mb-3">
              <Link
                to={"/adminDashboard/survey-management"}
                style={{ textDecoration: "none" }}
                className={`nav-link ${
                  isActive("/adminDashboard/survey-management") ? "active" : ""
                }`}
              >
                <i className={`bi bi-clipboard-check-fill`}></i>
                Survey Management
              </Link>
            </li>
        </ul>

        <div className="quote-box text-white mt-5 text-center">
          <div className="lightboxround">
            <i className="bi bi-lightbulb-fill"></i>
          </div>
          <p className="quoteheading mt-4 mb-3">Thoughts Time</p>
          <p className="mb-3">
            If you aren’t willing to own a stock for 10 years, don’t even think
            about owning it for 10 minutes.
          </p>
        </div>
      </div>

      <div className="logout-linkbox">
        <a href="/" className="logout-link" onClick={handleLogoutClick}>
          <i className="bi bi-box-arrow-right me-2"></i> Logout
        </a>
      </div>
    </div>
  );
};

export default AdminSidebar;
